import type { ReactNode } from 'react'
import { WorkspaceEmptyArtwork } from './WorkspaceEmptyArtwork'
import type { WorkspaceArtKind } from './workspace-art'
import s from './WorkspaceEmptyState.module.css'

export type WorkspaceEmptyKind = WorkspaceArtKind | 'needsYou'

interface WorkspaceEmptyStateProps {
  kind: WorkspaceEmptyKind
  title: string
  body?: ReactNode
  action?: ReactNode
  artwork?: ReactNode
  artFrameClassName?: string
  compact?: boolean
  state?: 'empty' | 'filtered' | 'selection'
  className?: string
}

/**
 * The shared illustrated zero state for Home cards and record indexes. The
 * artwork stays decorative; the live title/body carry the accessible meaning.
 */
export function WorkspaceEmptyState({
  kind,
  title,
  body,
  action,
  artwork,
  artFrameClassName,
  compact = false,
  state = 'empty',
  className,
}: WorkspaceEmptyStateProps) {
  const classes = [s.root, compact ? s.compact : '', className ?? '']
    .filter(Boolean)
    .join(' ')
  const artFrameClasses = [s.artFrame, artwork ? s.customArt : '', artFrameClassName ?? '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} data-kind={kind} data-state={state}>
      <div className={artFrameClasses} aria-hidden="true">
        {artwork ?? <WorkspaceEmptyArtwork kind={kind === 'needsYou' ? 'queue' : kind} />}
      </div>
      <div className={s.copy}>
        <p className={s.title}>{title}</p>
        {body ? <p className={s.body}>{body}</p> : null}
      </div>
      {action ? <div className={s.action}>{action}</div> : null}
    </div>
  )
}
